import { render, staticRenderFns } from "./msg4.vue?vue&type=template&id=2269e8db&scoped=true&"
import script from "./msg4.vue?vue&type=script&lang=js&"
export * from "./msg4.vue?vue&type=script&lang=js&"
import style0 from "./msg4.vue?vue&type=style&index=0&id=2269e8db&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2269e8db",
  null
  
)

export default component.exports